import React, { Component } from 'react'
import { Alert } from 'react-bootstrap';
import { Row, Card, Col, Jumbotron, Container, Table, Button } from 'react-bootstrap';
import { CSVLink } from "react-csv";
// ;
import Spinner from '../../subcomponent/spinner';
import funciones from '../../../middleware/funciones';
import config from '../../../config';

export class items extends Component {
    constructor(props) {
        super(props)
        const currentCompany = sessionStorage.getItem('company');
        this.uploadTxtFile = this.uploadTxtFile.bind(this);
        //this.uploadCsvFile = this.uploadCsvFile.bind(this);
        this.state = {
            csvData: [],
            txtData: [],
            listErrores: [],
            empresa: currentCompany,
            loadingText: false,
            mensajeProcess: "",
            estadoProcess: false,
            tipoAlert: "",
            infobase: [[]]
        }
    }

    componentDidMount = () => {
        const datasend = {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'empresa': this.state.empresa,
                'tipo': this.state.tipo,
            }
        }

        fetch(config.servBackEnd + '/items/baseinfo', datasend)
            .then(res => res.json())
            .then((data) => {
                if (data.ok) {
                    let infobase = [["ID_EMPRESA", "CODIGO_ITEM", "REFERENCIA_ITEM", "DESCRIPCION_ITEM", "IVA_ITEM", "RETEFUENTE_ITEM", "TIPO_ITEM", "GRUPO_ITEM", "LINEA_ITEM", "BAR_CODE"]]
                    const base = data.data;
                    for (let i = 0; i < base.length; i++) {
                        const element = base[i];
                        infobase.push([
                            element.ID_EMPRESA,
                            element.CODIGO_ITEM,
                            element.REFERENCIA_ITEM,
                            element.DESCRIPCION_ITEM,
                            element.IVA_ITEM,
                            element.RETEFUENTE_ITEM,
                            element.TIPO_ITEM,
                            element.GRUPO_ITEM,
                            element.LINEA_ITEM,
                            element.BAR_CODE
                        ])
                    }
                    this.setState({ infobase });
                } else {
                    this.setState({ controlData: false });
                }
            })
            .catch((error) => console.error(error))

    }

    uploadTxtFile(event) {
        this.setState({ loadingText: true });
        const listErrores = [];
        const fileReader = new FileReader();
        const file = event.target.files[0];

        const callback = (lines) => {
            const cabecera = "ID_EMPRESA,CODIGO_ITEM,REFERENCIA_ITEM,DESCRIPCION_ITEM,IVA_ITEM,RETEFUENTE_ITEM,TIPO_ITEM,GRUPO_ITEM,LINEA_ITEM,BAR_CODE";
            const arrayCabeceraBase = cabecera.split(",");
            const cabeceraFile = funciones.limpiezaCaracter(lines[0], ["\r", "\"", " "]);
            const arrayCabeceraFile = cabeceraFile.split(";")
            let infoitems = [];

            if (JSON.stringify(arrayCabeceraBase) === JSON.stringify(arrayCabeceraFile.slice(0, arrayCabeceraBase.length))) {
                this.setState({
                    mensajeProcess: "Cabeceras procesadas correctamente",
                    estadoProcess: true,
                    tipoAlert: "success"
                });
                for (let index = 1; index < lines.length - 1; index++) {
                    const element = lines[index];
                    const data = funciones.limpiezaCaracter(element, ["\r", "\""]);
                    const arrayData = data.split(";");
                    ////console.log(arrayCabeceraBase.length);
                    if (element.length > 0) {
                        infoitems.push(arrayData.slice(0, arrayCabeceraBase.length));
                    } else {
                        const men = "Error en los datos de la fila " + (index + 1);
                        this.setState({
                            mensajeProcess: men,
                            estadoProcess: true,
                            tipoAlert: "danger"
                        });
                    }
                }
            } else {
                this.setState({
                    mensajeProcess: "Error en la estructura, DESCARGUE EL ARCHIVO BASE",
                    estadoProcess: true,
                    tipoAlert: "danger"
                });
            }

            if (infoitems.length > 0) {
                const datasend = {
                    method: 'POST',
                    body: JSON.stringify({
                        infoitems,
                        arrayCabeceraBase
                    }),
                    headers: {
                        'Content-Type': 'application/json',
                        'empresa': this.state.empresa
                    }
                }

                fetch(config.servBackEnd + '/cargadata/cargaitems', datasend)
                    .then(res => res.json())
                    .then((data) => {
                        //console.log(data);
                        data.forEach(element => {
                            if (!element.ok) {
                                listErrores.push(element);
                            }
                        });
                        const mensaje = (listErrores.length > 0) ? "items actualizados correctamente con advertencias" : "items actualizados correctamente";
                        const tipo = (listErrores.length > 0) ? "warning" : "success";
                        this.setState({
                            loadingText: false,
                            mensajeProcess: mensaje,
                            estadoProcess: true,
                            tipoAlert: tipo,
                            listErrores
                        });
                    })
                    .catch((error) => console.error(error))
            } else {
                this.setState({ loadingText: false });
            }
        }


        fileReader.readAsText(file);
        fileReader.onloadend = function () {
            const lines = this.result.split('\n');
            callback(lines);
        }


    }
    render() {
        const { loadingText, estadoProcess, mensajeProcess, tipoAlert, listErrores, infobase } = this.state;
        return (
            <div>

                <Jumbotron className="Jumbotron">
                    <h2>Carga Masiva items</h2>
                </Jumbotron>
                <Container >
                    <Row>
                        <Col>
                            <Card>
                                <Card.Body>
                                    <Row className="justify-content-md-center" >
                                        <h4>Descargar archivo base</h4>
                                        <Col className="mb-2">
                                            <CSVLink data={infobase} filename={"carga_items.csv"} separator={";"}>
                                                <Button variant="success">Descargar</Button>
                                            </CSVLink>
                                        </Col>
                                    </Row>
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                    {(!loadingText) && <Row>
                        <Col>
                            <Card>
                                <Card.Body>
                                    <Row className="justify-content-md-center" >
                                        <h4>Carga archivo de Items</h4>
                                        <Col className="mb-2">
                                            <input type="file" name="myFile" accept=".csv" onChange={this.uploadTxtFile} className="btn btn-primary" />
                                        </Col>
                                    </Row>
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>}
                    {estadoProcess && <Row className="justify-content-md-center" ><Alert variant={tipoAlert}>{mensajeProcess}</Alert></Row>}
                    {listErrores.length > 0 && <Table striped bordered hover>
                        <thead>
                            <tr>
                                <th>No Linea</th>
                                <th>Mensaje de error</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                listErrores.map((data, i) => {
                                    return (<tr key={i}>
                                        <td>{data.linea}</td>
                                        <td>{data.msg}</td>
                                    </tr>)
                                })
                            }
                        </tbody>
                    </Table>
                    }
                    {(loadingText) && <Row>
                        <Col className="mb-2">
                            <Spinner loading={loadingText} />
                        </Col>
                    </Row>}
                </Container>
            </div>
        )
    }
}

export default items



// WEBPACK FOOTER //
// ./src/components/bussines/cargacatalogos/items.jsx